<template>
  <div>
    <Card>
      <Row class="search-con">
        <Col span="4">
          <Button @click="showAddModal" type="primary">添加</Button>
        </Col>
      </Row>
      <tables
        editable
        :columns="columns"
        v-model="tableData"
        :loading="tableLoading"
      />
      <Row class="page-con">
        <div class="page-bottom">
          <Page
            :current="page"
            :total="total"
            :page-size="pageSize"
            show-sizer
            show-elevator
            @on-change="changePage"
            @on-page-size-change="changePageSize"
          />
        </div>
      </Row>
    </Card>

    <Modal
      :mask-closable="false"
      v-model="addModal"
      title="添加策略"
      footer-hide
      >
      <forms :resetFlag="resetFlag"
        ref="addCommentRule"  
       @on-ok="addSumit" @on-cancel="cancel" />
    </Modal>
    
    <Modal
      :mask-closable="false"
      v-model="editModal"
      title="修改策略"
      footer-hide
      >
      <forms :resetFlag="resetFlag"
      ref="editCommentRule"  
       @on-ok="editSumit" @on-cancel="cancel" />
    </Modal>

  </div>
</template>

<script>
import Tables from "_c/tables/table-only.vue";
import Forms from "./add_comment_stratedy_rule_form.vue";
import { getStratedyRule, addCommentRule, editCommentRule, deleteCommentRule, getClassifys, getLiveType} from "@/api/data";
export default {
  name: "finance",
  components: {
    Tables,
    Forms,
  },
  data() {
    return {
      page: 1,
      total: 0,
      pageSize: 10,

      addModal: false,
      editModal: false,
      resetFlag: false,
      editData: {},
      tableLoading: true,
      allMoney: 0.0,
      startTime: "",
      endTime: "",
      columns: [
        {type: 'index', title: '序号',width: 100, align: "center"},
        { title: "使用gpt回复(百分比)" , key: "rule_gpt", align: "center", editable: true },
        { title: "打广告(百分比)" , key: "rule_advertisement", align: "center", editable: true },
        { title: "固定话术回复(百分比)" , key: "rule_org", align: "center", editable: true },
        { title: "交互多少次后开始打广告" , key: "advertisement_number", align: "center", editable: true },
        { title: "平台" , key: "live", align: "center", editable: true },
        { title: "所属分类" , key: "classify_name", align: "center", editable: true },
        { title: "所属标签" , key: "tag_name", align: "center", editable: true },
        {title: "类型",key: "action_type", align: "center"},
        { title: "创建时间", key: "create_time", align: "center", editable: true},
        {
          title: "Handle",
          key: "handle",
          render: (h, params) => {
            return h("div", [
              h(
                "Button",
                {
                  props: {
                    type: "text",
                    size: "small",
                  },
                  style: {
                    marginRight: "5px",
                  },
                  on: {
                    click: () => {
                      this.showEditModal(params);
                    },
                  },
                },
                "编辑"
              ),
              h(
                "Button",
                {
                  props: {
                    type: "text",
                    size: "small",
                  },
                  style: {
                    marginRight: "5px",
                  },
                  on: {
                    click: () => {
                      this.handleDelete(params);
                    },
                  },
                },
                "删除"
              ),
            ]);
          },
        },
      ],
      tableData: [],
    };
  },
  methods: {
    showAddModal() {
      this.addModal = true;
      this.resetFlag = !this.resetFlag;

      getLiveType().then((res) => {
        var liveTypes = res.data.data;
        this.$refs.addCommentRule.setLiveType(liveTypes);
      });

      getClassifys().then((res) => {
        var classifyIds = res.data.data.records;
        this.$refs.addCommentRule.setClassifyData(classifyIds);
      });

    },
    showEditModal(params) {
      this.editData = params.row;
      this.editModal = true;
      this.resetFlag = !this.resetFlag

      getLiveType().then((res) => {
        var liveTypes = res.data.data;
        this.$refs.editCommentRule.setLiveType(liveTypes);
      });

      getClassifys().then((res) => {
        var classifyIds = res.data.data.records;
        this.$refs.editCommentRule.setClassifyData(classifyIds);
        this.$refs.editCommentRule.setEditData(this.editData);
      });
    },
    addSumit(formValidate) {
      const data = {
        rule_gpt: formValidate.rule_gpt,
        rule_advertisement: formValidate.rule_advertisement,
        rule_org: formValidate.rule_org,
        advertisement_number: formValidate.advertisement_number,
        classify_id: formValidate.classify_id,
        tag_id: formValidate.tag_id,
        type: formValidate.type_id,
        live_id: formValidate.live_id
      };
      addCommentRule(data)
        .then((res) => {
          if (res.data.code == 200) {
            this.$Message.success("成功!");
            this.addModal = false;
            this.handleSearch();
          } else {
            this.$Message.error(res.data.msg);
          }
        })
        .catch((err) => {
          this.$Message.error("失败!");
        });
    },editSumit(formValidate) {
      const data = {
        rule_gpt: formValidate.rule_gpt,
        rule_advertisement: formValidate.rule_advertisement,
        rule_org: formValidate.rule_org,
        advertisement_number: formValidate.advertisement_number,
        classify_id: formValidate.classify_id,
        tag_id: formValidate.tag_id,
        type: formValidate.type_id,
        live_id: formValidate.live_id
      };
      editCommentRule(data, formValidate.id)
        .then((res) => {
          if (res.data.code == 200) {
            this.$Message.success("成功!");
            this.editModal = false;
            this.handleSearch();
          } else {
            this.$Message.error(res.data.msg);
          }
        })
        .catch((err) => {
          this.$Message.error("失败!");
        });
    },
    cancel() {},
    changePage(page) {
      this.page = page;
      this.handleSearch();
    },
    changePageSize(pageSize) {
      this.pageSize = pageSize;
      this.handleSearch();
    },
    handleSearch() {
      this.setTableLoading(true);
      let params = {
        page: this.page,
        pageSize: this.pageSize
      };
      getStratedyRule(params).then((res) => {
        if (res.data.code == 200) {
          this.tableData = res.data.data.records;
          this.total = res.data.data.total;
        } else {
          this.tableData = [];
          this.total = 0;
        }
        this.setTableLoading(false);
      });
    },
    handleDelete(params) {
        this.$Modal.confirm({
            title: '提示',
            content: '<p>是否确认删除？</p>',
            onOk: () => {
                 deleteCommentRule(params.row.id)
                .then((res) => {
                    if (res.data.code == 200) {
                        this.handleSearch()
                        this.$Message.success("成功!");
                    } else {
                        this.$Message.error(res.data.msg);
                    }
                }).catch((err) => {
                    this.$Message.error("失败!");
                });
            },
            onCancel: () => {
                this.$Message.info('已取消');
            }
        });
    },
    setTableLoading(state) {
      this.tableLoading = state;
    },
  },
  mounted() {
    this.handleSearch();
  },
};
</script>
